// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__39ZPX","flex":"Page_flex__1Eilj"};